import React from 'react'
import Header from '../Components/Header/Header'
import LoginUser from '../Components/Login/LoginUser'
function Login() {
  return (
    <div>
        <Header></Header>
        <LoginUser></LoginUser>
    </div>
  )
}

export default Login